import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { EvidenceFormRasComponent } from './evidence-form-ras/evidence-form-ras.component';
import { HypothesisFormRasComponent } from './hypothesis-form-ras/hypothesis-form-ras.component';
import { HypothesisValuesFormRasComponent } from './hypothesis-values-form-ras/hypothesis-values-form-ras.component';

export interface hypothesis {
  id: number;
  hypothesis: string;
}
export interface evidence {
  id: number;
  evidence: string;
}

export interface value {
  hypothesis: number;
  evidence: number;
  value: string;
}
@Component({
  selector: 'app-register-hypothesis-ras',
  templateUrl: './register-hypothesis-ras.component.html',
  styleUrls: ['./register-hypothesis-ras.component.scss'],
})
export class RegisterHypothesisRasComponent implements OnInit, AfterViewInit {
  // Formulario de hipotesis
  @ViewChild(HypothesisFormRasComponent)
  HypothesisFormRasComponent: HypothesisFormRasComponent;
  // Formulario de evidencias
  @ViewChild(EvidenceFormRasComponent)
  EvidenceFormRasComponent: EvidenceFormRasComponent;
  // Tabla de hipotesis evidencias y valores
  @ViewChild(HypothesisValuesFormRasComponent)
  HypothesisValuesFormRasComponent: HypothesisValuesFormRasComponent;

  constructor(private readonly fb: FormBuilder) {}

  ngAfterViewInit(): void {
    this.HypothesisValuesFormRasComponent.$editHypothes.subscribe({
      next: (hypothesis) => {
        this.editHypothesys(hypothesis);
      },
    });
    this.HypothesisValuesFormRasComponent.$editEvidence.subscribe({
      next: (evidence) => {
        this.editEvidence(evidence);
      },
    });
  }

  get isEditingHypothesis() {
    return this.HypothesisFormRasComponent?.isEditing;
  }
  get isEditingEvidence() {
    return this.EvidenceFormRasComponent?.isEditing;
  }

  @Input() data: { task: any };

  form = this.fb.group({
    hypothesis: [],
    evidences: [],
    values: [],
  });

  hypothesis: hypothesis[] = [];
  evidences: evidence[] = [];
  values: value[] = [];

  evidenceForm = this.fb.group({
    evidence: ['', [Validators.required]],
  });

  setValues() {
    this.form.controls.hypothesis.setValue(this.hypothesis);
    this.form.controls.evidences.setValue(this.evidences);
    this.form.controls.values.setValue(this.values);
  }

  ngOnInit() {
    const { task } = this.data;

    const formValues = task.data;
    const { values, evidences, hypothesis } = formValues;
    if (formValues) {
      if (values?.length > 0) {
        this.values = values;
      }
      if (evidences?.length > 0) {
        this.evidences = evidences;
      }
      if (hypothesis?.length > 0) {
        this.hypothesis = hypothesis;
      }
      this.form.patchValue(formValues);
    }
  }

  cancelEdit() {
    this.evidenceForm.reset();
  }

  editHypothesys(value: hypothesis) {
    this.HypothesisFormRasComponent.form.patchValue(value);
    this.HypothesisFormRasComponent.editingId = value.id;
  }

  editEvidence(value: evidence) {
    this.EvidenceFormRasComponent.form.patchValue(value);
    this.EvidenceFormRasComponent.editingId = value.id;
  }
}
